












































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import GenericAdd from "@/core/Generics/GenericAdd";
import UserResearchCenter from "@/models/security/userResearchCenter.Model";
import UserService from "@/services/user.service";
import BaseSelectPerson from "@/components/base/baseSelectPerson/baseSelectPerson.vue";
import BaseSelectResearchCenter from "@/components/base/baseSelectResearchCenter/baseSelectResearchCenter.vue";
import UserResearchCenterService from "../../services/UserResearchCenter.service";
import AnnoucementService from "@/services/researchCenter.service";
import Faculty from "../../models/faculty.model";
@Component({
  components: {
    baseSelectPerson: BaseSelectPerson,
    baseSelectResearchCenter: BaseSelectResearchCenter
  }
})
export default class FacultyAdd extends GenericAdd<Faculty> {
  active = false;
  loading: boolean = false;
  faculties = [];
  facultyRepository: AnnoucementService = new AnnoucementService();

  constructor() {
    super();
    this.controller = "Faculty";
    this.model = new Faculty();
  }

  protected async validate() {
    if (!this.model.name) {
      this.operationNoAllowed("Debe agregar una facultad");
      return;
    }

    let exist = this.faculties.some(
      (x: Faculty) => x.name.toLowerCase() == this.model.name.toLowerCase()
    );

    if (exist) {
      this.$buefy.toast.open({
        message: "Esta facultad ya existe en esta institución proponente",
        queue: false,
        duration: 4000,
        type: "is-danger",
        position: "is-top-right"
      });
      return;
    }

    try {
      var result = await this.$validator.validateAll();
      if (result) {
        this.add();
        return;
      }
      throw this.$validator.errors.items.map(e => e.msg);
    } catch (errors) {
      this.operationFailedErrors(errors);
    }
  }
  
  protected async add() {
    try {
      this.saving = true;
      let result = await this.repository.create(this.model);
      this.saving = false;
      this.$emit("add", result);
      this.clean();
      this.operationSuccess();

      if (this.exitOnSave) this.goBack();
    } catch (errors) {
      this.operationFailedErrors(errors);
    } finally {
      this.saving = false;
    }
  }

  goBack() {
    this.$router.push(`/faculties/${this.$route.params.id}`);
  }

  protected customCancel() {
    if (this.modelDoNotChange) {
      this.goBack();
      return;
    }
    this.$buefy.dialog.confirm({
      title: "Advertencia",
      type: "is-warning",
      size: "is-medium",
      hasIcon: true,
      confirmText: "Salir",
      cancelText: "No",
      message: "¿Seguro que desea salir de la sección?",
      onConfirm: () => this.goBack()
    });
  }

  async mounted() {
    let id = Number(this.$route.params.id);
    this.model.researchCenterId = id;
    var data = await this.facultyRepository.getFacultiesResearchCenterById(id);
    this.faculties = data.faculties ? data.faculties : [];
  }

  get user() {
    return this.$store.state.user;
  }
}
